// extracted by mini-css-extract-plugin
export default {"DzenPlay":"DzenPlayer_DzenPlay__9odF8"};